import React, { Component } from "react"
import Modal from "react-modal"
import CustomerUpdateModalUI from './CustomerUpdateModalUI'
import CacheKeys from "../../../cache/CacheKeys"
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils"
import CacheManager from "../../../cache/CacheManager"

class CustomerUpdateModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,

            submitted: false,

            contactFirstName: '',
            contactFirstNameError: null,
            contactLastName: '',
            contactLastNameError: null,
            contactPhone: '',
            contactPhoneError: null,
            contactEmail: '',
            contactEmailError: null,
            state: '',
            stateList: [],
            stateError: null,
            city: '',
            cityError: null,
            postalCode: '',
            postalCodeError: null,
            streetAddress: '',
            streetAddressError: null,
            CollectionDueInDays: '',
            CollectionDueInDaysError: null,
            enableEscrow: '',
            enableEscrowError: null,
        }
    }

    render() {
        console.log(this.props.updateMode)
        return (
            <CustomerUpdateModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}

                updateMode={this.props.updateMode}

                onUpdateClick={this.onSubmit}
                submitted={this.state.submitted}
                setErrorList={this.setErrorList}
                onCancelUpdate={this.onCancelUpdate}

                contactFirstName={this.state.contactFirstName}
                onContactFirstNameChange={(event) => { this.setState({ contactFirstName: event.target.value }) }}
                contactFirstNameError={this.state.contactFirstNameError}
                setContactFirstNameError={(error) => { this.setState({ contactFirstNameError: error }) }}

                contactLastName={this.state.contactLastName}
                onContactLastNameChange={(event) => { this.setState({ contactLastName: event.target.value }) }}
                contactLastNameError={this.state.contactLastNameError}
                setContactLastNameError={(error) => { this.setState({ contactLastNameError: error }) }}

                contactPhone={this.state.contactPhone}
                onContactPhoneChange={(event) => { this.setState({ contactPhone: event.target.value }) }}
                contactPhoneError={this.state.contactPhoneError}
                setContactPhoneError={(error) => { this.setState({ contactPhoneError: error }) }}

                contactEmail={this.state.contactEmail}
                onContactEmailChange={(event) => { this.setState({ contactEmail: event.target.value }) }}
                contactEmailError={this.state.contactEmailError}
                setContactEmailError={(error) => { this.setState({ contactEmailError: error }) }}

                enableEscrow={this.state.enableEscrow}
                onEnableEscrowChange={(event) => { this.setState({ enableEscrow: event.target.value }) }}
                enableEscrowError={this.state.enableEscrowError}
                setEnableEscrowError={(error) => { this.setState({ enableEscrowError: error }) }}

                state={this.state.state}
                onStateChange={(event) => { this.setState({ state: event.target.value }) }}
                stateError={this.state.stateError}
                setStateError={(error) => { this.setState({ stateError: error }) }}
                stateList={this.state.stateList}

                city={this.state.city}
                onCityChange={(event) => { this.setState({ city: event.target.value }) }}
                cityError={this.state.cityError}
                setCityError={(error) => { this.setState({ cityError: error }) }}

                postalCode={this.state.postalCode}
                onPostalCodeChange={(event) => { this.setState({ postalCode: event.target.value }) }}
                postalCodeError={this.state.postalCodeError}
                setPostalCodeError={(error) => { this.setState({ postalCodeError: error }) }}

                streetAddress={this.state.streetAddress}
                onStreetAddressChange={(event) => { this.setState({ streetAddress: event.target.value }) }}
                streetAddressError={this.state.streetAddressError}
                setStreetAddressError={(error) => { this.setState({ streetAddressError: error }) }}

                CollectionDueInDays={this.state.CollectionDueInDays}
                onCollectionDueInDaysChange={(event) => { this.setState({ CollectionDueInDays: event.target.value }) }}
                CollectionDueInDaysError={this.state.CollectionDueInDaysError}
                setCollectionDueInDaysError={(error) => { this.setState({ CollectionDueInDaysError: error }) }}
            />
        )
    }

    componentDidUpdate(prevProps) {
        let customer = this.props.selectedCustomer
        if (!customer)
            return
        if (prevProps.selectedCustomer && prevProps.selectedCustomer.customerId == customer.customerId)
            return

        console.log(customer)
        this.setState({
            customerName: customer.customerName,
            contactFirstName: customer.contactFirstName,
            contactLastName: customer.contactLastName,
            contactPhone: customer.contactPhone,
            enableEscrow: customer.enableEscrow,
            contactEmail: customer.contactEmail,
            state: customer.addressList[0].state,
            city: customer.addressList[0].city,
            postalCode: customer.addressList[0].postalCode,
            CollectionDueInDays: customer.CollectionDueInDays,
        })
    }

    onCancelUpdate = () => {
        this.setState({
            submitted: false, successMsg: null, errorList: null,
            //take care of
            contactFirstName: null, contactFirstNameError: null,
        })
        this.props.onCancelUpdate()
    }

    componentDidMount() {
        let context = this.props.context
        this.getState(context)
        Modal.setAppElement('body')
    }

    onSubmit = () => {
        let submitted = this.state.submitted
        if (submitted)
            return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        let id = this.props.selectedCustomer.customerId

        RestApiUtils.put(this.props.context,
            `/api/su/accounts/${this.props.account.accountId}/customers/${id}`,
            this.onSubmitCallback, {
            contactFirstName: this.state.contactFirstName,
            contactLastName: this.state.contactLastName,
            contactPhone: this.state.contactPhone,
            enableEscrow: this.state.enableEscrow,
            contactEmail: this.state.contactEmail,
            state: this.state.state,
            city: this.state.city,
            postalCode: this.state.postalCode,
            streetAddress: this.state.streetAddress,
            CollectionDueInDays: this.state.CollectionDueInDays,
        }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length !== 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null
                })
                this.props.onCancelUpdate()
                this.props.onRefreshClick()
            }, 1000)
        }
    }

    getState(context) {
        let cacheManager = new CacheManager({
            resource: `/api/pub/indiaStates`,
            cacheKey: CacheKeys.State(),
            callback: this.getStateCallback,
            ttlInSecs: 3600
        })
        cacheManager.getObject2(context)
    }

    getStateCallback = (response) => {
        let stateList = response.indiaStateList.map((state) => {
            return { key: state.code, value: state.name };
        });
        this.setState({ errorList: response.errorList, stateList: stateList })
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }
}

export default CustomerUpdateModalSF;